import { render, staticRenderFns } from "./newCenter.vue?vue&type=template&id=53df55ff&scoped=true"
import script from "./newCenter.vue?vue&type=script&lang=js"
export * from "./newCenter.vue?vue&type=script&lang=js"
import style0 from "./newCenter.vue?vue&type=style&index=0&id=53df55ff&prod&scoped=true&lang=scss"
import style1 from "./newCenter.vue?vue&type=style&index=1&id=53df55ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53df55ff",
  null
  
)

export default component.exports